import React from "react";
import styles from "../../pages/styles";

const AboutClasses = ({ title, desc, image }) => {
  return (
    <div className="px-4 md:px-20 pt-8 md:pt-10 max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
        <div className="flex-1 flex justify-center md:justify-start items-end md:order-first order-last">
          <img src={image} alt={title} className="w-full max-w-[320px] md:max-w-[350px]" />
        </div>
        <div className="flex-1 text-center md:text-left">
          <h2 className={`${styles.biggerheadingdark} mb-3 md:mb-4`}>
            {title}
          </h2>
          <p className={`${styles.paragraph} max-w-xl mx-auto md:mx-0`}>{desc}</p>
        </div>
      </div>
    </div>
  );
};

export default AboutClasses;
